import { CanvasMod } from './CanvasMod.js';
import { ResponsivePopupMod } from './ResponsivePopupMod.js';

let initialized_ = false;

/**
 * Extend leaflet defaults with Custom VEF features
 */
export function extendLeaflet() {
    if (initialized_ || !L) return;

    initialized_ = true;

    initProjections_();
    CanvasMod();
    ResponsivePopupMod();
}

/**
 * Helper function to init the default leaflet Projection CRS codes
 * @private
 */
function initProjections_() {
    const PROJECTION_DEFAULTS = {
        origin: [-1, -1],
        resolutions: [
            131072.0,
            65536.0,
            32768.0,
            16384.0,
            8192.0,
            4096.0,
            2048.0,
            1024.0,
            512.0,
            256.0,
            128,
            64,
            32,
            16,
            8,
            4,
            2,
            1,
            0.5,
            0.25,
            0.125,
            0.0625
        ]
    };

    // arctic projection
    L.CRS['EPSG3995'] = new L.Proj.CRS(
        'EPSG:3995',
        '+proj=stere +lat_0=90 +lat_ts=71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +datum=WGS84 +units=m +no_defs',
        PROJECTION_DEFAULTS
    );

    // antarctic projection
    L.CRS['EPSG3031'] = new L.Proj.CRS(
        'EPSG:3031',
        '+proj=stere +lat_0=-90 +lat_ts=-71 +lon_0=0 +k=1 +x_0=0 +y_0=0 +ellps=WGS84 +datum=WGS84 +units=m +no_defs',
        PROJECTION_DEFAULTS
    );

    // Webmercartor alias
    L.CRS['EPSG102100'] = new L.Proj.CRS(
        'EPSG:102100',
        '+proj=merc +a=6378137 +b=6378137 +lat_ts=0 +lon_0=0 +x_0=0 +y_0=0 +k=1 +units=m +nadgrids=@null +wktext +no_defs +type=crs',
        PROJECTION_DEFAULTS
    );
}